import './hamburger-menu.scss';

import { components } from 'gridstrap/lib/gs-components';

import { GSHamburgerMenu } from './hamburger-menu';


components.register({
	selector: '.gs-HamburgerMenu',
	controller: GSHamburgerMenu
});
